module.exports = __webpack_public_path__ + "img/fuwuinfo.861b0c29.png";